import { useMutation } from '@tanstack/react-query';
import { SelfServeSignup, SelfServeSignupGoogle } from 'common/contracts';
import useAxios from 'hooks/useAxios';

import { EApiRoutes, getApiRouteOrMock } from './api.utils';

export const useSelfServeSignup = () => {
  const axios = useAxios();

  const addNewUser = useMutation(
    async ({
      data,
      recaptchaToken
    }: {
      data: SelfServeSignup;
      recaptchaToken: string;
    }) => {
      return await axios.post(
        getApiRouteOrMock(EApiRoutes.SELF_SERVE_SIGNUP),
        data,
        recaptchaToken ? { 'x-recaptcha-token': recaptchaToken } : undefined
      );
    },
    {}
  );

  const addNewUserGoogle = useMutation(
    async ({
      data,
      recaptchaToken
    }: {
      data: SelfServeSignupGoogle;
      recaptchaToken: string;
    }) => {
      const response = await axios.post(
        getApiRouteOrMock(EApiRoutes.SELF_SERVE_SIGNUP_GOOGLE),
        data,
        recaptchaToken ? { 'x-recaptcha-token': recaptchaToken } : undefined
      );
      return response.data;
    },
    {}
  );

  const resendConfirmationEmail = useMutation(
    async ({ email }: { email: string }) => {
      return await axios.post(
        getApiRouteOrMock(
          EApiRoutes.SELF_SERVE_SIGNUP_RESEND_CONFIRMATION_EMAIL
        ),
        { email }
      );
    },
    {}
  );

  const verifyUser = useMutation(
    async ({
      userId,
      verificationToken
    }: {
      userId: string;
      verificationToken: string;
    }) => {
      const url = `${getApiRouteOrMock(EApiRoutes.SELF_SERVE_SIGNUP_VERIFY_USER)}/${userId}/verify/${verificationToken}`;
      const response = await axios.put(url, {
        userId,
        verificationToken
      });
      return response;
    },
    {}
  );

  return {
    addNewUser,
    addNewUserGoogle,
    resendConfirmationEmail,
    verifyUser
  };
};
